// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changeHandling-wrapper .p-column-header-content {
  padding: 8px 13px;
}

.changeHandling-wrapper .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  height: calc(100% - 218px);
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .changeHandling-wrapper .p-datatable > .p-datatable-wrapper {
    height: calc(100% - 260px);
  }
}

.changeHandling .task-field-width {
  width: 400px;
}
.changeHandling .non-task-width {
  width: 110px;
}
.changeHandling .role-field-width {
  width: 120px;
}
.changeHandling .customized-min-width {
  width: 80px;
}

.historyTable .p-datatable > .p-datatable-wrapper {
  height: calc(100vh - 180px);
}

.historyTable th.p-resizable-column.p-reorderable-column {
  width: 100px;
  text-align: center;
  white-space: normal !important;
  word-break: break-all !important;
  padding: 0 5px;
  background-color: #edf4fa !important;
}

.historyTable td {
  width: 100px;
}

.historyTable .p-dialog-content {
  overflow-y: auto;
  flex-grow: 1;
  overflow-x: scroll;
  position: relative;
  display: flex;
}

.historyTable .p-treetable-scrollable-header-box {
  margin-right: 0 !important;
}

.historyTable .columnFilterIcon {
  font-size: 12px;
  font-weight: 200;
  cursor: pointer;
}

.columnFilterIcon.sort-asc {
  filter: hue-rotate(180deg) brightness(1.2);
}

.columnFilterIcon.sort-desc {
  filter: none;
}

.clearAllFilter:hover {
  background: #e1edf8;
}

.sortAndFrozen:hover {
  color: #003da5;
}

.dsbpScreen-multiselect-dropdown .p-checkbox {
  display: inline-flex !important;
  margin-right: 8px;
  vertical-align: middle;
}
.dsbpScreen-multiselect-dropdown .p-multiselect-item {
  display: flex !important;
  align-items: center;
  font-size: 13px;
  color: #222;
  padding: 4px 9px !important;
  flex-direction: row-reverse !important;
}
.dsbpScreen-multiselect-dropdown .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  width: 100%;
}
.dsbpScreen-multiselect-dropdown .p-multiselect-items-wrapper {
  padding: 0px !important;
}
.dsbpScreen-multiselect-dropdown .p-multiselect-label {
  font-size: 13px;
  color: #222;
  font-weight: 400;
}

.acp-filters {
  padding: 1.25rem;
}

.changeHandling .myProjectAnddAllProjectList table thead th {
  padding: 3px 7px !important;
}

.actions-history {
  display: flex;
  flex-direction: row-reverse;
  margin: 15px 60px 5px 4px;
}

.history-dialog .p-dialog-content {
  padding: 0px 30px 15px !important;
}

input.dsbp-history-filter-input {
  border-radius: 6px;
  line-height: 12px;
  color: #495057 !important;
  background: #ffffff;
  padding: 0.75rem 0.75rem;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  appearance: none;
}

.mainTable .p-treetable .p-treetable-thead > tr > th {
  background-color: #ffffff !important;
}

.selected-row {
  background-color: #e1edf8 !important;
}

.p-column-title {
  font-weight: 400;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.history-dialog button.p-dialog-header-icon.p-dialog-header-close.p-link {
  position: absolute;
  top: 12px;
  right: 30px;
}

.history-dialog .action-button-changeHandling {
  margin-right: 35px;
}

.history-dialog .p-dialog-header {
  padding: 0 !important;
  margin: 0;
}

.history-dialog .p-icon {
  width: 15px;
  height: 15px;
}

.table-footer {
  position: absolute;
  bottom: 5.5rem;
  max-height: 30px;
  padding-right: 10px;
}

.font-bold {
  font-weight: 700;
}

.awm_cic_status {
  width: 110px;
}

.cic-tooltip-target {
  display: flex;
}
.cic-tooltip-target[title]:hover::after {
  content: attr(title);
  position: absolute;
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}

.footerIconsMain {
  display: flex;
  align-items: center;
}
.footerIconsMain:first-child {
  margin-left: 0;
}

.footerIconAll {
  font-size: 16px;
}

.footerIcons2 {
  color: #ff0000;
  rotate: 180deg;
}

.footerIcons3 {
  color: #01ff1a;
}

.footerIcons4 {
  color: #ff0000;
  margin-right: 10px;
}

.footerIcons5 {
  color: #01ff1a;
}

.footerIcons6 {
  color: red;
}

.footerIcons7 {
  color: gray;
}

.footerIcons8 {
  color: #01ff1a;
}

.footerIcons9 {
  color: #ff0000;
}

.footerIcons10 {
  font-weight: bold;
  color: black;
}

.footerIcons11 {
  font-weight: bold;
  color: black;
}

.filter-active {
  cursor: pointer !important;
  margin-left: 10px;
  height: 20px;
}

.filter-inactive {
  cursor: default !important;
  margin-left: 10px;
  height: 20px;
}

.icon-header {
  padding-top: 8px;
  display: flex;
  gap: 16px;
}

.status {
  display: flex;
  justify-content: center;
}

.frozen-col-width {
  min-width: 50px;
  width: 100px;
  max-width: 100px;
}

.history-dialog {
  width: 80%;
}

.historyTable {
  width: 100%;
}

.historyTable .p-treetable-scrollable-body {
  overflow: hidden;
  position: relative;
}

.changeHandling .p-treetable .p-treetable-thead > tr > th,
.changeHandling .p-treetable.p-treetable-gridlines .p-treetable-tbody > tr > td {
  width: 120px;
}

.action-button-changeHandling {
  display: flex;
  gap: 1.25rem;
}

.actions-changeHandling {
  padding-right: 2.625rem;
  display: flex;
  justify-content: space-between;
  padding: 0.938rem 2.625rem;
}
.actions-changeHandling .actionButtons {
  display: flex;
}

.sort-label {
  color: #003DA5;
  font-weight: 600;
}

.filter-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-container .clearIcon {
  cursor: pointer;
  margin-right: 4px;
  color: #888;
}

.wrapIconHistory {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.action-button-history {
  margin-right: 10px;
  display: flex;
  gap: 1.25rem;
}

.history-row {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

.plus-icon {
  font-weight: 900;
  font-size: 10px;
  color: #1976d2;
}

.changeHandling .card {
  position: relative;
}

.loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.historyLoader {
  text-align: center;
  padding: 2rem;
}

.historyTreeTable {
  border: none;
  background: inherit;
}

.HistoryData {
  padding: 2rem;
  text-align: center;
  word-break: break-all;
}

.HistoryDataFound {
  white-space: pre-wrap;
  text-align: left;
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  max-height: 40vh;
  overflow: auto;
}

.noDataFound {
  margin-top: 1rem;
  color: #888;
}

.cursor {
  cursor: pointer;
}

.checkbox-col {
  width: 40px !important;
  text-align: center !important;
}

.changeHandling-wrapper .form-buttons {
  padding: 10px !important;
  max-height: 55px;
}

.changeHandling .p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {
  border-width: 1px !important;
}

.table-footer .footerIcons {
  z-index: 999;
}

.buttonContainer {
  display: flex;
  justify-content: center;
}

.okButton {
  background-color: #ffffff !important;
  border: 2px solid #003da5 !important;
  color: #003da5 !important;
}

.okButton.btn.btn-primary:hover {
  background-color: #003da5 !important;
  border: 2px solid #003da5 !important;
  color: #ffffff !important;
}

.confirmation-popup .p-dialog-title {
  text-align: center;
  color: #d37302;
}

.confirmation-popup .p-dialog-content {
  padding: 0px 30px 15px !important;
}

@media screen and (min-width: 1440px) {
  .changeHandling.myProjectAnddAllProjectList .p-datatable > .p-datatable-wrapper {
    max-height: 84vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DSBP/ChangeHandling/ChangeHandling.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAGA;EACI,cAAA;EACA,0BAAA;EACA,WAAA;AAAJ;AAEI;EALJ;IAMM,0BAAA;EACJ;AACF;;AAGE;EACE,YAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;;AAOE;EACE,2BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,cAAA;EACA,oCAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAMA;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAHJ;;AAKA;EACI,0BAAA;AAFJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAIA;EACE,0CAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAKE;EACE,+BAAA;EACA,iBAAA;EACA,sBAAA;AAFJ;AAIE;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,sCAAA;AAFJ;AAIE;EACE,WAAA;AAFJ;AAIE;EACE,uBAAA;AAFJ;AAIE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAIA;EACI,2BAAA;AADJ;;AAGA;EACI,aAAA;EACA,2BAAA;EACA,yBAAA;AAAJ;;AAGE;EACE,iCAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iFAAA;EACA,gBAAA;AAAJ;;AAEA;EACE,oCAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AAAA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;;AADA;EACI,kBAAA;EACC,SAAA;EACD,WAAA;AAIJ;;AADA;EACI,kBAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,SAAA;AAKJ;;AAHA;EACE,WAAA;EACA,YAAA;AAMF;;AAJA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,YAAA;AAOF;;AALA;EACE,aAAA;AAQF;AANE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AAQJ;;AAJA;EACE,aAAA;EACA,mBAAA;AAOF;AALE;EACE,cAAA;AAOJ;;AAHA;EACE,eAAA;AAMF;;AAFA;EACE,cAAA;EACA,cAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,cAAA;EACA,kBAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,WAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,iBAAA;EACA,YAAA;AAKF;;AAFA;EACE,iBAAA;EACA,YAAA;AAKF;;AADA;EACE,0BAAA;EACA,iBAAA;EACA,YAAA;AAIF;;AADA;EACE,0BAAA;EACA,iBAAA;EACA,YAAA;AAIF;;AAFA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAKF;;AAHA;EACI,aAAA;EACA,uBAAA;AAMJ;;AAJA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AAOF;;AALA;EACE,UAAA;AAQF;;AANA;EACI,WAAA;AASJ;;AAPA;EACI,gBAAA;EACA,kBAAA;AAUJ;;AARA;;EAEE,YAAA;AAWF;;AATA;EACE,aAAA;EACA,YAAA;AAYF;;AAVA;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,0BAAA;AAaF;AAXE;EACE,aAAA;AAaJ;;AAVA;EACE,cAAA;EACA,gBAAA;AAaF;;AAXA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAcF;;AAZA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AAeF;;AAbA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAgBF;;AAdA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AAiBF;;AAfA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;AAkBF;;AAhBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAmBF;;AAjBA;EACE,kBAAA;AAoBF;;AAlBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAqBF;;AAnBA;EACE,kBAAA;EACA,aAAA;AAsBF;;AApBA;EACE,YAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AAwBF;;AAtBA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAyBF;;AAvBA;EACE,gBAAA;EACA,WAAA;AA0BF;;AAxBA;EACE,eAAA;AA2BF;;AAzBA;EACE,sBAAA;EACA,6BAAA;AA4BF;;AA1BA;EACE,wBAAA;EACA,gBAAA;AA6BF;;AA3BA;EACE,4BAAA;AA8BF;;AA5BA;EACI,YAAA;AA+BJ;;AA7BA;EACE,aAAA;EACA,uBAAA;AAgCF;;AA9BA;EACI,oCAAA;EACA,oCAAA;EACA,yBAAA;AAiCJ;;AA/BA;EACI,oCAAA;EACA,oCAAA;EACA,yBAAA;AAkCJ;;AAhCA;EACE,kBAAA;EACA,cAAA;AAmCF;;AAjCA;EACE,iCAAA;AAoCF;;AAlCA;EACE;IACE,2BAAA;EAqCF;AACF","sourcesContent":[".changeHandling-wrapper .p-column-header-content {\n    padding: 8px 13px;\n}\n\n\n.changeHandling-wrapper .p-datatable > .p-datatable-wrapper {\n    overflow: auto;\n    height: calc(100% - 218px);\n    width: 100%;\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100% - 260px);\n    }\n  }\n\n.changeHandling {\n  .task-field-width {\n    width: 400px;\n  }\n\n  .non-task-width {\n    width: 110px;\n  }\n\n  .role-field-width {\n    width: 120px;\n  }\n\n  .customized-min-width {\n    width: 80px;\n  }\n}\n.historyTable {\n  .p-datatable > .p-datatable-wrapper {\n    height: calc(100vh - 180px);\n  }\n}\n.historyTable th.p-resizable-column.p-reorderable-column {\n    width: 100px;\n    text-align: center;\n    white-space: normal !important;\n    word-break: break-all !important;\n    padding: 0 5px;\n    background-color: #edf4fa !important;\n}\n\n.historyTable td {\n    width: 100px;\n}\n.historyTable .p-dialog-content {\n    overflow-y: auto;\n    flex-grow: 1;\n    overflow-x: scroll;\n    position: relative;\n    display: flex;\n}\n.historyTable .p-treetable-scrollable-header-box{\n    margin-right: 0 !important;\n}\n.historyTable .columnFilterIcon{\n    font-size: 12px;\n    font-weight: 200;\n    cursor: pointer;\n}\n\n.columnFilterIcon.sort-asc {\n  filter: hue-rotate(180deg) brightness(1.2);\n  \n}\n.columnFilterIcon.sort-desc {\n  filter: none;\n}\n\n.clearAllFilter:hover {\n  background: #e1edf8;\n}\n\n.sortAndFrozen:hover {\n  color: #003da5;\n}\n// --- MultiSelect dropdown panel and items ---\n.dsbpScreen-multiselect-dropdown {\n  .p-checkbox {\n    display: inline-flex !important;\n    margin-right: 8px;\n    vertical-align: middle;\n  }\n  .p-multiselect-item {\n    display: flex !important;\n    align-items: center;\n    font-size: 13px;\n    color: #222;\n    padding: 4px 9px !important;\n    flex-direction: row-reverse !important;\n  }\n  .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n    width: 100%;\n  }\n  .p-multiselect-items-wrapper {\n    padding: 0px !important;\n  }\n  .p-multiselect-label {\n    font-size: 13px;\n    color: #222;\n    font-weight: 400;\n  }\n}\n.acp-filters{\n    padding: 1.25rem;\n}\n.changeHandling .myProjectAnddAllProjectList table thead th{\n    padding: 3px 7px !important;\n}\n.actions-history {\n    display: flex;\n    flex-direction: row-reverse;\n    margin: 15px 60px 5px 4px;\n}\n.history-dialog {\n  .p-dialog-content {\n    padding: 0px 30px 15px !important;\n}\n}\ninput.dsbp-history-filter-input {\n    border-radius: 6px;\n    line-height: 12px;\n    color: #495057 !important;\n    background: #ffffff;\n    padding: 0.75rem 0.75rem;\n    border: 1px solid #ced4da;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n    appearance: none;\n }\n.mainTable .p-treetable .p-treetable-thead > tr > th {\n  background-color: #ffffff !important;\n}\n.selected-row {\n  background-color: #e1edf8 !important;\n}\n.p-column-title{\n  font-weight: 400;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.history-dialog button.p-dialog-header-icon.p-dialog-header-close.p-link {\n    position: absolute;\n     top: 12px;\n    right: 30px;\n}\n\n.history-dialog .action-button-changeHandling {\n    margin-right: 35px;\n}\n.history-dialog .p-dialog-header {\n    padding: 0 !important;\n    margin: 0;\n}\n.history-dialog .p-icon{\n  width: 15px;\n  height: 15px;\n}\n.table-footer {\n  position: absolute;\n  bottom: 5.5rem;\n  max-height: 30px;\n  padding-right: 10px;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.awm_cic_status{\n  width: 110px;\n}\n.cic-tooltip-target {\n  display: flex;\n\n  &[title]:hover::after {\n    content: attr(title);\n    position: absolute;\n    background: #333;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n    z-index: 1000;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-top: 5px;\n  }\n}\n\n.footerIconsMain {\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.footerIconAll {\n  font-size: 16px;\n}\n\n// Icon color styles\n.footerIcons2 {\n  color: #ff0000;\n  rotate: 180deg;\n}\n\n.footerIcons3 {\n  color: #01ff1a;\n}\n\n.footerIcons4 {\n  color: #ff0000;\n  margin-right: 10px;\n}\n\n.footerIcons5 {\n  color: #01ff1a;\n}\n\n.footerIcons6 {\n  color: red;\n}\n\n.footerIcons7 {\n  color: gray;\n}\n\n.footerIcons8 {\n  color: #01ff1a;\n}\n\n.footerIcons9 {\n  color: #ff0000;\n}\n\n.footerIcons10 {\n  font-weight: bold;\n  color: black;\n}\n\n.footerIcons11 {\n  font-weight: bold;\n  color: black;\n}\n\n// Filter icon specific styling\n.filter-active {\n  cursor: pointer !important;\n  margin-left: 10px;\n  height: 20px;\n}\n\n.filter-inactive {\n  cursor: default !important;\n  margin-left: 10px;\n  height: 20px;\n}\n.icon-header{\n  padding-top: 8px;\n  display: flex;\n  gap: 16px;\n}\n.status{\n    display: flex;\n    justify-content: center;\n}\n.frozen-col-width{\n  min-width: 50px;\n  width: 100px;\n  max-width: 100px;\n}\n.history-dialog{\n  width: 80%;\n}\n.historyTable {\n    width: 100%;\n}\n.historyTable .p-treetable-scrollable-body {\n    overflow: hidden;\n    position: relative;\n}\n.changeHandling .p-treetable .p-treetable-thead > tr > th,\n.changeHandling .p-treetable.p-treetable-gridlines .p-treetable-tbody > tr > td{\n  width: 120px;\n}\n.action-button-changeHandling{\n  display: flex;\n  gap: 1.25rem;\n}\n.actions-changeHandling {\n  padding-right: 2.625rem;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.938rem 2.625rem;\n\n  .actionButtons {\n    display: flex;\n  }\n}\n.sort-label{\n  color: #003DA5;\n  font-weight: 600;\n}\n.filter-container{\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.filter-container .clearIcon{\n  cursor: pointer;\n  margin-right: 4px;\n  color: #888;\n}\n.wrapIconHistory{\n  cursor: pointer;\n  width: 20px;\n  height: 20px\n}\n.action-button-history{\n  margin-right: 10px;\n  display: flex;\n  gap: 1.25rem;\n}\n.history-row{\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  justify-content: center;\n}\n.plus-icon{\n  font-weight: 900;\n  font-size: 10px;\n  color: #1976d2;\n}\n.changeHandling .card{\n  position: relative;\n}\n.loader{\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  background: rgba(255,255,255,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: all;\n}\n.historyLoader{\n  text-align: center;\n  padding: 2rem;\n}\n.historyTreeTable{\n  border: none;\n  background: inherit;\n}\n.HistoryData{\n  padding: 2rem;\n  text-align: center;\n  word-break: break-all;\n}\n.HistoryDataFound{\n  white-space: pre-wrap;\n  text-align: left;\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 4px;\n  max-height: 40vh;\n  overflow: auto;\n}\n.noDataFound{\n  margin-top: 1rem;\n  color: #888;\n}\n.cursor{\n  cursor: pointer;\n}\n.checkbox-col{\n  width: 40px !important;\n  text-align: center !important;\n}\n.changeHandling-wrapper .form-buttons{\n  padding: 10px !important;\n  max-height: 55px;\n}\n.changeHandling .p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th{\n  border-width: 1px !important;\n}\n.table-footer .footerIcons {\n    z-index: 999;\n}\n.buttonContainer{\n  display: flex;\n  justify-content: center;\n}\n.okButton{\n    background-color: #ffffff !important;\n    border: 2px solid #003da5 !important;\n    color: #003da5 !important;\n}\n.okButton.btn.btn-primary:hover{\n    background-color: #003da5 !important;\n    border: 2px solid #003da5 !important;\n    color: #ffffff !important;\n}\n.confirmation-popup .p-dialog-title{\n  text-align: center;\n  color:#d37302\n}\n.confirmation-popup .p-dialog-content{\n  padding: 0px 30px 15px !important\n}\n@media screen and (min-width: 1440px) {\n  .changeHandling.myProjectAnddAllProjectList .p-datatable > .p-datatable-wrapper {\n    max-height: 84vh !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
